import jsPDF from "jspdf";
import { font, fontBold } from "@/assets/fonts/Sarabun-normal.js";

export default {
    methods: {
        async generateBookDeliveryPurchaseByCourseReportPdf() {
            try {
                this.isDisableDownloadReportBtn = true;

                let pdf = new jsPDF(this.pdfOption);

                const pdf_width = pdf.internal.pageSize.width;
                const pdf_height = pdf.internal.pageSize.height;

                const margin_l = this.pdfConfig.margin.l;
                const margin_t = this.pdfConfig.margin.t;
                const margin_b = this.pdfConfig.margin.b;

                let cellHeight = 20;

                const addNewPageIfNeeded = (incrementValue) => {
                    if (pdf_position_y + incrementValue >= pdf_height - margin_t) {
                        pdf.addPage();
                        pdf_position_y = margin_t; // Reset the position to the top of the new page
                    } else {
                        pdf_position_y += incrementValue; // Add the input value
                    }
                };

                let pdf_position_y = 0;
                pdf.addFileToVFS("Sarabun-Regular.ttf", fontBold);
                pdf.addFont("Sarabun-Regular.ttf", "Sarabun", "bold");
                pdf.addFileToVFS("Sarabun-Regular.ttf", font);
                pdf.addFont("Sarabun-Regular.ttf", "Sarabun", "normal");

                pdf.setFont("Sarabun", "bold");
                pdf.setFontSize(this.pdfConfig.typo.header);
                pdf_position_y += margin_t;
                this.thaitext(
                    pdf,
                    "รายงานการซื้อที่ต้องรับ/ส่งหนังสือ",
                    pdf_width / 2,
                    pdf_position_y,
                    0,
                    "center",
                );
                addNewPageIfNeeded(this.pdfConfig.endLarge);

                pdf.setFont("Sarabun", "normal");
                pdf.setFontSize(this.pdfConfig.typo.extraSmall);

                this.thaitext(
                    pdf,
                    "วันที่พิมพ์ : " +
                    " " +
                    this.formatDateToThai(this.moment().format("YYYY-MM-DD"), false),
                    pdf_width - 40,
                    pdf_position_y,
                    0,
                    "right",
                );
                addNewPageIfNeeded(this.pdfConfig.endNormal);

                this.thaitext(
                    pdf,
                    "ผู้พิมพ์ข้อมูล : " +
                    " " +
                    (this.currentProfile ? this.currentProfile.fullName : "-"),
                    pdf_width - 40,
                    pdf_position_y,
                    0,
                    "right",
                );
                addNewPageIfNeeded(this.pdfConfig.endRow);

                let hasPurchaseDate = this.purchaseDate.start ? true : false;
                let startDate = this.moment(this.purchaseDate.start).format(
                    "YYYY-MM-DD",
                );
                let endDate = this.moment(this.purchaseDate.end).format("YYYY-MM-DD");
                this.thaitext(
                    pdf,
                    "ข้อมูลวันที่ : " +
                    (hasPurchaseDate
                        ? this.formatDateToThai(startDate, false) +
                        " - " +
                        this.formatDateToThai(endDate, false)
                        : "-"),
                    margin_l,
                    pdf_position_y,
                );
                addNewPageIfNeeded(this.pdfConfig.endNormal);

                this.thaitext(
                    pdf,
                    "สถาบัน : " + this.instituteName,
                    margin_l,
                    pdf_position_y,
                );
                addNewPageIfNeeded(this.pdfConfig.endNormal);

                this.thaitext(
                    pdf,
                    "ประเภทการรับหนังสือ : " + this.selectedBookReceivingTypeText,
                    margin_l,
                    pdf_position_y
                );
                addNewPageIfNeeded(this.pdfConfig.endNormal);

                this.thaitext(
                    pdf,
                    "สาขา : " + this.selectedBranchText,
                    margin_l,
                    pdf_position_y
                );
                addNewPageIfNeeded(this.pdfConfig.endNormal);

                this.thaitext(
                    pdf,
                    "วิชา : " + (this.selectedSubjectText || "ทั้งหมด"),
                    margin_l,
                    pdf_position_y,
                );
                addNewPageIfNeeded(this.pdfConfig.endNormal);

                this.thaitext(
                    pdf,
                    "ชื่อคอร์ส : " + (this.selectedCourse?.courseName || "ทั้งหมด"),
                    margin_l,
                    pdf_position_y,
                );
                addNewPageIfNeeded(this.pdfConfig.endRow);

                const tableHeader = [
                    "ลำดับ",
                    "รหัสคอร์ส",
                    "หลักสูตร",
                    "จำนวน (เล่ม)",
                ];
                const colWidths = [30, 70, 210, 55];
                let headerX = 40;
                pdf.setLineWidth(0.1);
                pdf.setFont("Sarabun", "bold");

                const fontSize = pdf.getFontSize();
                const fontHeight = fontSize * 0.3528;
                let lineSpacing = 5; // Extra padding between multiline texts

                const renderTableHeader = () => {
                    pdf.setFont("Sarabun", "bold");

                    for (let i = 0; i < tableHeader.length; i++) {
                        const width = colWidths[i];

                        // 1. Draw Header Cell Border
                        pdf.rect(headerX, pdf_position_y, width, cellHeight);

                        // 2. Split text by newline for multiline support
                        const lines = tableHeader[i].split("\n");
                        const totalLines = lines.length;

                        // Calculate the starting Y position so the entire block of text is vertically centered
                        const totalTextHeight =
                            totalLines * fontHeight + (totalLines - 1) * lineSpacing;
                        let startY =
                            pdf_position_y + (cellHeight - totalTextHeight) / 2 + fontHeight;

                        // 3. Loop through and center each individual line
                        for (let j = 0; j < totalLines; j++) {
                            const lineText = lines[j];

                            // Calculate horizontal center for the current line
                            const textWidth =
                                (pdf.getStringUnitWidth(lineText) * fontSize) /
                                pdf.internal.scaleFactor;
                            const textX = headerX + (width - textWidth) / 2;

                            // Render the text using your custom Thai text function
                            this.thaitext(pdf, lineText, textX, startY);

                            // Move Y down for the next line
                            startY += fontHeight + lineSpacing;
                        }

                        headerX += width;
                    }
                    pdf_position_y += cellHeight;

                    pdf.setFont("Sarabun", "normal");
                };

                const getThaiWordWrappedLines = (pdf, text, maxWidth) => {
                    // 1. แยกคำตามหลักภาษาไทยด้วย Intl.Segmenter
                    const segmenter = new Intl.Segmenter("th", { granularity: "word" });
                    const segments = Array.from(segmenter.segment(text)).map(
                        (s) => s.segment,
                    );

                    const lines = [];
                    let currentLine = "";

                    // 2. วนลูปนำคำมาต่อกัน ถ้าความกว้างเกิน maxWidth ให้ขึ้นบรรทัดใหม่
                    for (const word of segments) {
                        const testLine = currentLine + word;
                        // คำนวณความกว้างของข้อความทดสอบ (ปรับวิธีการวัดความกว้างตาม pdf-lib หรือ jspdf ที่ใช้งาน)
                        const testWidth = pdf.getTextWidth
                            ? pdf.getTextWidth(testLine)
                            : pdf.getStringUnitWidth(testLine) * fontSize;

                        if (testWidth > maxWidth && currentLine !== "") {
                            lines.push(currentLine);
                            currentLine = word;
                        } else {
                            currentLine = testLine;
                        }
                    }

                    if (currentLine) {
                        lines.push(currentLine);
                    }

                    return lines;
                };

                // Create table header
                renderTableHeader();

                pdf.setFont("Sarabun", "normal");
                cellHeight = 20;
                let finalRowHeight = Math.max(cellHeight);

                const maxPrintableY = pdf_height - margin_b;

                this.bookDeliveryPurchaseList.forEach((row, index) => {
                    let columnX = margin_l;
                    const padding = 10;

                    const courseCode = row.courseCode ? row.courseCode.toString() : "-";
                    const courseCodeLines = pdf.splitTextToSize(
                        courseCode,
                        colWidths[1] - padding,
                    );
                    const courseNameLines = getThaiWordWrappedLines(
                        pdf,
                        row.courseName,
                        colWidths[2] - padding,
                    );

                    // 1. Split long text into arrays of wrapped lines
                    // const padding = 10;

                    // 2. Calculate heights for individual text blocks
                    const fontHeight = pdf.getFontSize() * 0.3528;
                    lineSpacing = 7;
                    const calculatedCourseNameHeight =
                        courseNameLines.length * fontHeight +
                        (courseNameLines.length - 1) * lineSpacing +
                        10;
                    const calculatedCourseCodeHeight =
                        courseCodeLines.length * fontHeight +
                        (courseCodeLines.length - 1) * lineSpacing +
                        10;

                    finalRowHeight = Math.max(
                        cellHeight,
                        calculatedCourseNameHeight,
                        calculatedCourseCodeHeight,
                    );

                    // ==========================================
                    // CRITICAL FIX: AUTOMATIC PAGE BREAK CHECK
                    // ==========================================
                    if (pdf_position_y + finalRowHeight > maxPrintableY) {
                        pdf.addPage();
                        pdf_position_y = margin_t; // Reset to the top of the new page

                        // RE-DRAW TABLE HEADERS ON THE NEW PAGE
                        headerX = 40;
                        renderTableHeader();
                    }
                    // ==========================================

                    // --- DRAW COLUMN 1: No. ---
                    pdf.rect(columnX, pdf_position_y, colWidths[0], finalRowHeight);
                    const idxText = (index + 1).toString();
                    const idxWidth =
                        (pdf.getStringUnitWidth(idxText) * pdf.getFontSize()) /
                        pdf.internal.scaleFactor;
                    this.thaitext(
                        pdf,
                        idxText,
                        columnX + (colWidths[0] - idxWidth) / 2,
                        pdf_position_y + (finalRowHeight - fontHeight) / 2 + fontHeight,
                    );
                    columnX += colWidths[0];

                    // --- DRAW COLUMN 2: Course Code ---
                    pdf.rect(columnX, pdf_position_y, colWidths[1], finalRowHeight);
                    const totalCourseCodeHeight =
                        courseCodeLines.length * fontHeight +
                        (courseCodeLines.length - 1) * lineSpacing;
                    let courseCodeY =
                        pdf_position_y +
                        (finalRowHeight - totalCourseCodeHeight) / 2 +
                        fontHeight;
                    courseCodeLines.forEach((line) => {
                        this.thaitext(pdf, line, columnX + 5, courseCodeY);
                        courseCodeY += fontHeight + lineSpacing;
                    });
                    columnX += colWidths[1];

                    // --- DRAW COLUMN 3: Course Name ---
                    pdf.rect(columnX, pdf_position_y, colWidths[2], finalRowHeight);
                    const totalCourseNameHeight =
                        courseNameLines.length * fontHeight +
                        (courseNameLines.length - 1) * lineSpacing;
                    let courseNameY =
                        pdf_position_y +
                        (finalRowHeight - totalCourseNameHeight) / 2 +
                        fontHeight;

                    courseNameLines.forEach((line) => {
                        this.thaitext(pdf, line, columnX + 5, courseNameY);
                        courseNameY += fontHeight + lineSpacing;
                    });
                    columnX += colWidths[2];

                    // --- DRAW COLUMN 4: Book Count ---
                    pdf.rect(columnX, pdf_position_y, colWidths[3], finalRowHeight);
                    const bookCountText = row.totalCount ? row.totalCount.toString() : '-';
                    const bookCountWidth =
                        (pdf.getStringUnitWidth(bookCountText) * pdf.getFontSize()) /
                        pdf.internal.scaleFactor;
                    this.thaitext(
                        pdf,
                        bookCountText,
                        columnX + (colWidths[3] - bookCountWidth) / 2,
                        pdf_position_y + (finalRowHeight - fontHeight) / 2 + fontHeight,
                    );
                    columnX += colWidths[3];

                    // 4. Move Y down cleanly by the shared unified row height
                    pdf_position_y += finalRowHeight;
                });

                // ==========================================
                // DRAW THE TOTAL SUMMARY ROW
                // ==========================================

                // 1. Calculate total sum dynamically from your list
                const totalBooks = this.bookDeliveryPurchaseList.reduce(
                    (sum, row) => sum + (Number(row.totalCount) || 0),
                    0,
                );

                // 2. Check if there is enough space on the current page for the summary row
                if (pdf_position_y + finalRowHeight > maxPrintableY) {
                    pdf.addPage();
                    pdf_position_y = margin_t; // Reset to top if it overflows
                }

                // 3. Set the font style to Bold for the summary row
                pdf.setFont("Sarabun", "bold");

                let currentX = margin_l;

                // Combine widths of Column 1, 2, and 3 for the text "รวมทั้งหมด"
                const spanWidth = colWidths[0] + colWidths[1] + colWidths[2];

                // Draw the rectangle background for the spanned section (optional grey background like the image)
                pdf.setFillColor(240, 240, 240); // Light grey color
                pdf.rect(currentX, pdf_position_y, spanWidth, finalRowHeight, "F"); // Fill background
                pdf.rect(currentX, pdf_position_y, spanWidth, finalRowHeight, "S"); // Draw border stroke

                // Calculate text width for right alignment with a small padding (e.g., 15 units from the right edge)
                const labelText = "รวมทั้งหมด";
                const labelWidth =
                    (pdf.getStringUnitWidth(labelText) * pdf.getFontSize()) /
                    pdf.internal.scaleFactor;
                const labelX = currentX + spanWidth - labelWidth - 15;
                const labelY =
                    pdf_position_y + (finalRowHeight - fontHeight) / 2 + fontHeight;

                // Render "รวมทั้งหมด"
                this.thaitext(pdf, labelText, labelX, labelY);

                // Move currentX to the 4th column (Book Count)
                currentX += spanWidth;

                // 4. Draw Column 4: Total sum number box
                pdf.setFillColor(240, 240, 240);
                pdf.rect(currentX, pdf_position_y, colWidths[3], finalRowHeight, "F");
                pdf.rect(currentX, pdf_position_y, colWidths[3], finalRowHeight, "S");

                const totalText = totalBooks.toString();
                const totalWidth =
                    (pdf.getStringUnitWidth(totalText) * pdf.getFontSize()) /
                    pdf.internal.scaleFactor;
                // Center align the total number in the last column
                const totalX = currentX + (colWidths[3] - totalWidth) / 2;

                this.thaitext(pdf, totalText, totalX, labelY);

                pdf_position_y += finalRowHeight;

                // =========================================================================
                // DRAW PAGE NUMBERS (ALWAYS PLACE AT THE VERY END OF YOUR SCRIPT)
                // =========================================================================

                const totalPages = pdf.internal.getNumberOfPages();

                pdf.setFont("Sarabun", "normal");
                pdf.setFontSize(this.pdfConfig.typo.extraSmall);

                for (let i = 1; i <= totalPages; i++) {
                    pdf.setPage(i);

                    // Render top-right page counter
                    this.thaitext(
                        pdf,
                        `${i} / ${totalPages}`,
                        pdf_width - 20,
                        20,
                        0,
                        "right"
                    );
                }

                setTimeout(() => {
                    pdf.save("รายงานการซื้อที่ต้องรับ/ส่งหนังสือ.pdf");
                }, 0);
                this.isDisableDownloadReportBtn = false;
            } catch (error) {
                console.log(error);
            }
        },
    },
};
